import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useConfirmSavedFiles } from 'v2/hooks';
import { BulkFilesSelection } from '../../formSteps/BulkFilesSelection';
import { BulkFilesUploadForm, UseStepFlowProps, StepFlow } from '../../types';
import { useBulkFileUploadSchema } from '../useBulkFileUploadSchema';
import { getFormErrorMessage, buildBulkFilesConfirmations } from './utils';

export function useBulkFileImportStepFlow({
  bulkImportType,
  onBulkImportTypeChange,
}: UseStepFlowProps): StepFlow<BulkFilesUploadForm> {
  const [showModal, setShowModal] = useState(true);
  const bulkFileUploadSchema = useBulkFileUploadSchema();
  const formContext = useForm<BulkFilesUploadForm>({
    mode: 'onChange',
    resolver: yupResolver(bulkFileUploadSchema),
    defaultValues: {
      bulkUploadFiles: [],
    },
  });

  const {
    setValue,
    formState: { errors },
  } = formContext;

  const formErrorMessage = getFormErrorMessage(errors);

  useEffect(() => {
    setValue('bulkImportType', bulkImportType);
  }, [bulkImportType]);

  const {
    mutate: confirmSavedFiles,
    isLoading,
    isSuccess,
  } = useConfirmSavedFiles({ onClose: () => setShowModal(false) });

  const handleOnSubmit = (data: BulkFilesUploadForm) => {
    const bulkFilesConfirmations = buildBulkFilesConfirmations(data);
    confirmSavedFiles(bulkFilesConfirmations);
  };

  return {
    show: showModal,
    formContext,
    isSuccess,
    isLoading,
    onSubmit: handleOnSubmit,
    steps: [
      {
        name: 'Files flow - BulkFilesSelectionStep',
        body: function BulkFilesSelectionStep() {
          return (
            <BulkFilesSelection
              isBulkUploadFileLoading={isLoading}
              onBulkImportTypeChange={onBulkImportTypeChange}
            />
          );
        },
        next: {
          name: 'SAVE',
          handler: 'submit',
          tooltip: formErrorMessage,
        },
      },
    ],
  };
}
